import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControl,
  Button,
  Typography,
  Box,
  TextField,
  Select,
  MenuItem,
  InputLabel,
  Chip,
  OutlinedInput,
} from "@mui/material";
import AppSelectInputApi from "../../../common/components/ui/AppSelectInputApi";

const BadResponseDialog = ({ open, onClose, onSubmit }) => {
  const [selectedReasons, setSelectedReasons] = useState([]);
  const [feedbackText, setFeedbackText] = useState("");

  const handleSubmit = () => {
    if (
      selectedReasons.length > 0 &&
      (!selectedReasons.includes("other") || feedbackText.trim())
    ) {
      onSubmit(selectedReasons, feedbackText);
      setSelectedReasons([]);
      setFeedbackText("");
    }
  };

  const handleClose = () => {
    setSelectedReasons([]);
    setFeedbackText("");
    onClose();
  };

  const handleReasonChange = (value) => {
    setSelectedReasons(value);
  };

  const isSubmitDisabled =
    selectedReasons.length === 0 ||
    (selectedReasons.includes("other") && !feedbackText.trim());

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      sx={{
        "& .MuiDialog-paper": {
          borderRadius: "12px",
        },
      }}
    >
      <DialogTitle>
        <Typography variant="h6" sx={{ fontWeight: 600 }}>
          Pourquoi ce message ne vous convient pas?
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
          Votre retour d'information nous aidera a améliorer notre service.
        </Typography>
      </DialogTitle>

      <DialogContent>
        <FormControl fullWidth sx={{ mb: 3 }}>
          <AppSelectInputApi
            name="feedbackTypeCode"
            label="Raison"
            onChange={handleReasonChange}
            multiple
            apiOptions={{
              api: "api/referential/feedback-type",
            }}
            value={selectedReasons}
            /*startAdornment={
                    <img
                      src={OperateurEcoIcon}
                      alt="world"
                      style={{
                        width: "20px",
                        height: "20px",
                        paddingRight: "5px",
                      }}
                    />
                  }
                  error={typeOperatorError}*/
          />
        </FormControl>

        <TextField
          fullWidth
          multiline
          rows={4}
          label={
            selectedReasons.includes("other")
              ? "Veuillez préciser (obligatoire)"
              : "Commentaires supplémentaires (facultatif)"
          }
          placeholder="Parlez-nous de votre expérience..."
          value={feedbackText}
          onChange={(e) => setFeedbackText(e.target.value)}
          required={selectedReasons.includes("other")}
          error={selectedReasons.includes("other") && !feedbackText.trim()}
          helperText={
            selectedReasons.includes("other") && !feedbackText.trim()
              ? "Ce champ est obligatoire lorsque « Autre » est sélectionné"
              : ""
          }
          sx={{
            "& .MuiOutlinedInput-root": {
              borderRadius: "8px",
            },
          }}
        />
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 3 }}>
        <Button onClick={handleClose} color="secondary">
          Annuler
        </Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          disabled={isSubmitDisabled}
          sx={{
            backgroundColor: "#F44336",
            "&:hover": {
              backgroundColor: "#D32F2F",
            },
          }}
        >
          Envoyer
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default BadResponseDialog;
